import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { loadProjects } from '../redux/actions/projectAction';
import { ProjectResponseWithCache } from '../redux/types/projectTypes';

/**
 * Custom hook to ensure project data is loaded
 * This hook can be used in any component that needs project data
 * Note: This hook no longer automatically loads data on mount
 */
export const useProjectData = () => {
  const dispatch = useAppDispatch();
  const { projects, loading, error, pagination } = useAppSelector(state => state.projects);

  // Use a ref to track if we've already dispatched a load action
  const hasDispatchedRef = useRef(false);

  // Add a ref to track if we've received an empty response
  const noProjectsFoundRef = useRef(false);

  // Add retry count state to prevent infinite loops
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 3;

  // Remove automatic loading on mount - only return data that's already in Redux
  // Components should explicitly call loadProjects when needed

  return {
    projects: projects || [],
    // If we've hit max retries, don't show loading state anymore
    loading: loading && retryCount < MAX_RETRIES,
    // If we've hit max retries, show a more helpful error
    error:
      retryCount >= MAX_RETRIES
        ? 'Server appears to be unavailable. Please try again later.'
        : error,
    // Include pagination data from Redux
    pagination,
  };
};
